import script from "./popupHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./popupHeader.vue?vue&type=script&setup=true&lang=js"

import "./popupHeader.vue?vue&type=style&index=0&id=0dc8bad8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc8bad8"]])

export default __exports__